export const EARLY_BIRD_PLANS = ["starter", "pro"];
export const EARLY_BIRD_TYPE = "coupon";
export const EARLY_BIRD_COUPON = "early-bird";
